module.exports = __webpack_public_path__ + "public/files/img/calls.c7ccabb0.gif";